import { useEffect, useRef } from "react";

import { useExplorerGlobals } from "contexts/explorerGlobals";
import { telemetry } from "telemetry";

/** How often to sample render stats for always-on executive FPS metrics (ms). */
export const RENDER_PERF_SAMPLE_INTERVAL_MS = 5_000;

/**
 * Headless always-on sampler for render performance (FPS / CPU / GPU / primitives).
 *
 * Mount whenever a view is ready so executive Honeycomb boards receive `render.fps`
 * without requiring the debug stats overlay (`?debug=true`).
 */
export function RenderPerfSampler() {
    const {
        state: { view },
    } = useExplorerGlobals(true);
    const viewRef = useRef(view);
    viewRef.current = view;

    useEffect(() => {
        const timer = setInterval(() => {
            if (typeof document !== "undefined" && document.visibilityState === "hidden") {
                return;
            }

            const stats = viewRef.current?.statistics?.render;
            if (!stats) {
                return;
            }

            telemetry.recordRenderPerf({
                fps: 1000 / (stats.frameInterval ?? 1),
                cpuTime: stats.cpuTime.draw ?? 0,
                gpuTime: stats.gpuTime.draw ?? 0,
                primitives: stats.primitives ?? 0,
            });
        }, RENDER_PERF_SAMPLE_INTERVAL_MS);

        return () => clearInterval(timer);
    }, []);

    return null;
}
